// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const ShoebillChickSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'shoebill-chick-eggIdle',
    metadata: {
      frames: {
        'shoebill-chick-eggIdle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-eggIdle-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill-chick/eggIdle.png',
        size: {
          w: 224,
          h: 32,
        },
        scale: '1',
      },
      animations: {
        'shoebill-chick-eggIdle': [
          'shoebill-chick-eggIdle-0',
          'shoebill-chick-eggIdle-1',
          'shoebill-chick-eggIdle-2',
          'shoebill-chick-eggIdle-3',
          'shoebill-chick-eggIdle-4',
          'shoebill-chick-eggIdle-5',
          'shoebill-chick-eggIdle-6',
        ],
      },
    },
  },
  {
    name: 'shoebill-chick-outOfAnEgg',
    metadata: {
      frames: {
        'shoebill-chick-outOfAnEgg-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-7': {
          frame: {
            x: 224,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-8': {
          frame: {
            x: 256,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-9': {
          frame: {
            x: 288,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-10': {
          frame: {
            x: 320,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-11': {
          frame: {
            x: 352,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-outOfAnEgg-12': {
          frame: {
            x: 384,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill-chick/outOfAnEgg.png',
        size: {
          w: 416,
          h: 32,
        },
        scale: '1',
      },
      animations: {
        'shoebill-chick-outOfAnEgg': [
          'shoebill-chick-outOfAnEgg-0',
          'shoebill-chick-outOfAnEgg-1',
          'shoebill-chick-outOfAnEgg-2',
          'shoebill-chick-outOfAnEgg-3',
          'shoebill-chick-outOfAnEgg-4',
          'shoebill-chick-outOfAnEgg-5',
          'shoebill-chick-outOfAnEgg-6',
          'shoebill-chick-outOfAnEgg-7',
          'shoebill-chick-outOfAnEgg-8',
          'shoebill-chick-outOfAnEgg-9',
          'shoebill-chick-outOfAnEgg-10',
          'shoebill-chick-outOfAnEgg-11',
          'shoebill-chick-outOfAnEgg-12',
        ],
      },
    },
  },
  {
    name: 'shoebill-chick-idle',
    metadata: {
      frames: {
        'shoebill-chick-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-idle-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-idle-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-idle-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-idle-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill-chick/idle.png',
        size: {
          w: 160,
          h: 32,
        },
        scale: '1',
      },
      animations: {
        'shoebill-chick-idle': [
          'shoebill-chick-idle-0',
          'shoebill-chick-idle-1',
          'shoebill-chick-idle-2',
          'shoebill-chick-idle-3',
          'shoebill-chick-idle-4',
        ],
      },
    },
  },
  {
    name: 'shoebill-chick-walk',
    metadata: {
      frames: {
        'shoebill-chick-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-7': {
          frame: {
            x: 224,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-8': {
          frame: {
            x: 256,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-9': {
          frame: {
            x: 288,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-10': {
          frame: {
            x: 320,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-walk-11': {
          frame: {
            x: 352,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill-chick/walk.png',
        size: {
          w: 384,
          h: 32,
        },
        scale: '1',
      },
      animations: {
        'shoebill-chick-walk': [
          'shoebill-chick-walk-0',
          'shoebill-chick-walk-1',
          'shoebill-chick-walk-2',
          'shoebill-chick-walk-3',
          'shoebill-chick-walk-4',
          'shoebill-chick-walk-5',
          'shoebill-chick-walk-6',
          'shoebill-chick-walk-7',
          'shoebill-chick-walk-8',
          'shoebill-chick-walk-9',
          'shoebill-chick-walk-10',
          'shoebill-chick-walk-11',
        ],
      },
    },
  },
  {
    name: 'shoebill-chick-kamikaze',
    metadata: {
      frames: {
        'shoebill-chick-kamikaze-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
        'shoebill-chick-kamikaze-7': {
          frame: {
            x: 224,
            y: 0,
            w: 32,
            h: 32,
          },
          sourceSize: {
            w: 32,
            h: 32,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 32,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill-chick/kamikaze.png',
        size: {
          w: 256,
          h: 32,
        },
        scale: '1',
      },
      animations: {
        'shoebill-chick-kamikaze': [
          'shoebill-chick-kamikaze-0',
          'shoebill-chick-kamikaze-1',
          'shoebill-chick-kamikaze-2',
          'shoebill-chick-kamikaze-3',
          'shoebill-chick-kamikaze-4',
          'shoebill-chick-kamikaze-5',
          'shoebill-chick-kamikaze-6',
          'shoebill-chick-kamikaze-7',
        ],
      },
    },
  },
];
